<div
  *ngIf="currentAlert"
  [@slideDown]="animationState"
  class="severe-weather-banner banner-danger"
>
  <div class="banner-content">
    <div class="banner-text">
      <div class="banner-title">Severe Weather Warning</div>
      <div class="banner-message">{{ currentAlert.message }}</div>
    </div>
    <button class="btn-dismiss" (click)="onDismiss()" aria-label="Dismiss">&times;</button>
  </div>
</div>
